import { render, staticRenderFns } from "./xvapp.vue?vue&type=template&id=187080d5&"
import script from "./xvapp.vue?vue&type=script&lang=js&"
export * from "./xvapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports